export default __webpack_public_path__ + "static/media/authImage.208ccb5a.jpg";